import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { colors } from 'kangarootime-ui';
import { ClipLoader } from 'react-spinners';

const DestructiveDialog = ({ isOpen, onClose, destructiveAction, title, body, performingAction }) => (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {body}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>
        Cancel
      </Button>
      <Button onClick={destructiveAction} style={{ color: !performingAction && colors.danger }} disabled={performingAction}>
        Yes
      </Button>
      { performingAction
        ? <ClipLoader size={14} color='#FF7CC3' />
        : null
      }
    </DialogActions>
  </Dialog>
);

DestructiveDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  destructiveAction: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
  performingAction: PropTypes.bool
};

DestructiveDialog.defaultProps = {
  performingAction: false
};

export default DestructiveDialog;
